<template>

    <Page>

        <ImageAndText 
            src="/SuccessLeavesATrail/results.png"
            animation="fade"
            floor-shadow
            border>

            <h2 class="mb-4">Telematics unlocks retention</h2>
            <p class="font-normal text-white/80">
                The magic of telematics unfolds when it empowers dealers to reach
                out to customers at precisely the right moment - warning them, enticing them
                and delivering unbeatable convenience.  This not only elevates the customer 
                experience but also <span class="text-emerald-500 font-semibold">gives dealers the coveted "first-dibs"</span> at capturing
                service opportunities.
            </p>
            
        </ImageAndText>

        <KeyMessage animate>
            When translated into revenue, these improvements can 
            represent millions of dollars for an average sized dealership
        </KeyMessage>

        <div class="hidden lg:block absolute bottom-[16%] translate-x-32 text-white px-2 rounded shadow bg-[#a52c40]">
            * Based on 2023 Urban Science Report
        </div>

    </Page>

</template>